import { makeStyles, Typography } from "@material-ui/core"
import React from "react"
import { configureEnvironment } from "../../config/env"
import notFoundImage from "../img/404-notfound.svg"
import Botao from "./Botao"

const AcessoNegado = (props) => {
	const classes = useStyles(props)
	const urlMyPardini = configureEnvironment().REACT_APP_URL_PAGINA_INICIAL_MY_PARDINI
	return (
		<div className={classes.root}>
			<div className={classes.imgContent}>
				<img src={notFoundImage} className={classes.imagem} alt="Imagem Não Encontrado" />
			</div>
			<div>
				<Typography className={classes.saudacao}>Desculpe,</Typography>
				<Typography className={classes.descricao}>Você não tem permissão para executar essa ação.</Typography>
				<br />
				<Botao titulo="Ir para MyPardini" href={urlMyPardini} type="primary" fullWidth uppercase={false} />
			</div>
		</div>
	)
}

const useStyles = makeStyles({
	root: {
		maxWidth: "45ch",
		margin: "auto",
	},
	saudacao: {
		fontSize: "60px",
		fontWeight: "500",
		lineHeight: "76px",
		color: "#61688B",
	},
	descricao: {
		fontSize: "34px",
		fontWeight: "bold",
		lineHeight: "43px",
		color: "#23144D",
	},
	imgContent: {
		display: "flex",
		transform: "translateY(50px)",
	},
	imagem: {
		margin: "auto 15px auto auto",
		width: "68%",
	},
})

export default AcessoNegado
